export default {
  breakpoints: {
    keys: ["md", "lg"],
    values: {
      md: 1024,
      lg: 1440,
    },
  },
  direction: "ltr",
  spaces: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28,
  },
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    base: {
      c00: "#F2F2F2",
      c01: "#D9D9D9",
      c02: "#B2B2B2",
      c03: "#999999",
      c04: "#808080",
      c05: "#404040",
    },
    primary: {
      c00: "#F1F1FD", // Disabled Background //Blue 000
      c01: "#D4D5F6", // Disabled Font //Blue 100
      c03: "#3D42C4", // Switch On Background
      c02: "#565ADD", // Background // Blue 200
      c04: "#3D42C4", // Hover Background // Blue 300
      c05: "#F1F1FD", // Banner Background
    },
    buttonColor: {
      c00: "#E7E9EB", // Disabled Background //Blue 000
      c01: "#B4B4B6", // Disabled Font //Blue 100
      c03: "#3D42C4", // Switch On Background
      c02: "#565ADD", // Background // Blue 200
      c04: "#3D42C4", // Hover Background // Blue 300
      c05: "#EAEAFB", // Banner Background
    },
    secondary: {
      c00: "#FFC3E2",
      c01: "#FF82BE",
      c02: "#FF419B",
      c03: "#FF0077",
      c04: "#CC005F",
      c05: "#FFEBF5",
    },
    text: {
      c00: "#DADCEE",
      c01: "#4E4E54",
      c02: "#686C9D",
      c03: "#02020A",
      c04: "#02020A",
      c05: "#D7D9DB",
    },
    background: {
      c00: "#FFFFFF",
      c01: "#F6FAFC",
      c02: "#EEF0F2",
      c03: "#D9D9DA",
      tertiary: "#F8F8F8",
    },
    info: {
      c00: "#E7E9EB", // Disabled Background //Blue 000
      c01: "#B4B4B6", // Disabled Font //Blue 100
      c03: "#3D42C4", // Switch On Background
      c02: "#565ADD", // Background // Blue 200
      c04: "#3D42C4", // Hover Background // Blue 300
      c05: "#EAEAFB", // Banner Background
    },
    warning: {
      c00: "#FFF7EB",
      c01: "#FFEDD1",
      c02: "#E39519",
      c03: "#F4B758",
      c04: "#FFF7EB",
      c05: "#FFF7EB",
    },
    success: {
      c00: "#E9FBF5",
      c01: "#C8FFEB",
      c02: "#009961",
      c03: "#16C083",
      c04: "#28A138",
      c05: "#E9FBF5",
    },
    error: {
      c00: "#FAE8E8",
      c01: "#FACDCD",
      c02: "#CC4141",
      c03: "#FA5050",
      c04: "#FFE6E6",
      c05: "#FFEBEB",
    },
    dark: {
      c000: "#D9D9DA",
      c100: "#B4B4B6",
      c200: "#4E4E54",
      c300: "#02020A",
    },
    light: {
      c000: "#FFFFFF",
      c100: "#F6F6F7",
      c200: "#EEF0F2",
      c300: "#E7E9EB",
    },
    orange: {
      c000: "#FFFBF9",
      c100: "#FFF6F1",
      c200: "#FF5E00",
      c300: "#CC4B00",
    },
    green: {
      c000: "#E9FBF5",
      c100: "#C8FFEB",
      c200: "#16C083",
      c300: "#009961",
      c400: "#28A138",
    },
    yellow: {
      c000: "#FFF7EB",
      c100: "#FFEDD1",
      c200: "#F4B758",
      c300: "#E39519",
    },
    red: {
      c000: "#FAE8E8",
      c100: "#FACDCD",
      c200: "#FA5050",
      c300: "#CC4141",
    },
  },
  shadows: {
    0: "none",
    1: "0px 2px 4px rgb(79 81 110 / 30%)",
    2: "0px 0px 10px rgba(0, 0, 0, 0.08);",
    3: "inset 0px 0px 10px rgba(0, 0, 0, 0.08);",
    10: "0px 0px 4px rgba(54, 42, 102, 0.16);",
    20: "0px 8px 20px 1px rgba(54, 42, 102, 0.1);",
  },
  typography: {
    baseFontSize: 16,
    baseFontFamily: "Inter",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontFamily: {
      regular: {
        fontWeight: 400,
      },
      medium: {
        fontWeight: 500,
      },
      semibold: {
        fontWeight: 500,
      },
    },
    title: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "28px",
    },
    description: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "28px",
    },
    h1: {
      fontSize: "24px",
      lineHeight: "36px",
      letterSpacing: "0px",
      margin: "0px",
      fontWeight: 600,
    },
    h2: {
      fontSize: "18px",
      lineHeight: "28px",
      letterSpacing: "0.5px",
      margin: "0px",
      fontWeight: 600,
    },
    h3: {
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0.15px",
      margin: "0px",
      fontWeight: 600,
    },
    body: {
      fontSize: "14px",
      letterSpacing: "0.25px",
      lineHeight: "20px",
      fontStyle: "normal",
      fontWeight: 400,
    },
    bodyLight: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.25px",
      fontWeight: "400",
    },
    bodySmall: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.4px",
      fontWeight: 400,
    },
    bodySemiBold: {
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.25px",
      fontWeight: 400,
    },
    label: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.25px",
      fontWeight: 500,
    },
    placeholder: {
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.25px",
      fontWeight: 400,
      color: "#BABEC2",
    },
    buttonText: {
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.25px",
      fontWeight: 500,
    },
    helperText: {
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.4px",
      fontWeight: 400,
    },
    captionText: {
      fontSize: "12px",
      lineHeight: "18px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      fontWeight: 300,
    },
  },
  borderRadius: {
    primary: 4,
    secondary: 24,
    tertiary: 8,
  },
  transitions: {
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  zIndex: {
    context: 800,
    hoverOver: 1000,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    popover: 1000,
    tooltip: 1500,
    rail: 1600,
  },
};
